import type { ToolCatalog, ToolCatalogTool } from "./types";

/** The `workflow` namespace is reserved for vammo-minions workflows (RFC-0004 §3). */
export const WORKFLOW_GROUP = "workflow";

export const isWorkflowGroup = (tool: ToolCatalogTool) => tool.name === WORKFLOW_GROUP;

/** The tool groups of the catalog, plus one group with the workflows as `workflow.<id>` actions. */
export function capabilityGroups(catalog: ToolCatalog | undefined, workflowDescription: string): ToolCatalogTool[] {
  if (!catalog) return [];
  const tools = catalog.tools.filter((tool) => !isWorkflowGroup(tool));
  const workflows = catalog.workflows ?? [];
  if (workflows.length === 0) return tools;
  return [
    ...tools,
    {
      name: WORKFLOW_GROUP,
      description: workflowDescription,
      actions: workflows.map((workflow) => ({
        name: workflow.id,
        ref: workflow.ref,
        description: workflow.description,
        kind: workflow.kind,
      })),
    },
  ];
}
